export function calculateScore( courseStatus ){

    if( courseStatus.passed === 0 ){
        return 0;
    }

    const score = Math.round( (courseStatus.passed / courseStatus.scoAmount) * 100 );
    return score / 100;
}
